import { Controller } from "@hotwired/stimulus"
import { useTransition, useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["container", "outsideClose", "focus", "mainButton"]
  static values = {
    outsideOpenId: String,
    outsideOpenTarget: String,
    hiddenByDefault: { type: Boolean, default: true },
    disableBodyScroll: Boolean
  }

  connect() {
    this.element.addEventListener("modal:open", this.open.bind(this))
    this.element.addEventListener("modal:close", this.hide.bind(this))
    this.element.addEventListener("keydown", this.handleOnKeydown.bind(this))

    useTransition(this, { element: this.containerTarget }) // stimulus-use
    if (this.hiddenByDefaultValue) {
      this.containerTarget.classList.add("hidden")
    } else if (!document.documentElement.hasAttribute("data-turbo-preview")) {
      this.containerTarget.classList.remove("hidden")
    }

    if (this.outsideOpenTargetValue) {
      document.querySelectorAll(this.outsideOpenTargetValue).forEach(element => {
        element.onclick = this.open.bind(this)
      })
    }

    if (this.outsideOpenIdValue && document.getElementById(this.outsideOpenIdValue)) {
      document.getElementById(this.outsideOpenIdValue).onclick = this.open.bind(this)
    }

    if (this.hasOutsideCloseTarget) {
      useClickOutside(this, {
        element: this.outsideCloseTarget
      })
    }
  }

  open() {
    this.enter()
    this.containerTarget.classList.remove("hidden")
    if (this.disableBodyScrollValue) {
      document.body.classList.add("overflow-hidden")
    }
    if (this.hasFocusTarget) {
      this.previouslyFocused = document.activeElement
      this.focusTarget.focus()
      if (this.focusTarget.select) this.focusTarget.select()
    }
  }

  hide(event) {
    event.preventDefault()

    this.containerTarget.classList.add("hidden")
    if (this.disableBodyScrollValue) {
      document.body.classList.remove("overflow-hidden")
    }
    const eventValue = new Event("modal:value")
    eventValue.value = event.currentTarget?.dataset?.value
    this.element.dispatchEvent(eventValue)
    if (this.hasFocusTarget && this.previouslyFocused) {
      this.previouslyFocused.focus()
      this.previouslyFocused = null
    }
    this.leave()
  }

  handleOnKeydown(event) {
    switch (event.key) {
      case "Enter":
        if (event.target.tagName === "TEXTAREA") return // aby dalo sie wprowadzic nowa linie w textarea na modalu
        event.preventDefault()
        this.confirm()
        break
      case "Escape":
        event.preventDefault()
        this.hide(event)
        break
    }
  }

  confirm() {
    if (this.hasMainButtonTarget) {
      this.mainButtonTarget.click()
    }
  }

  clickOutside(event) {
    this.hide(event)
  }
}
